import React, { useContext, useState, useEffect } from "react";
import { developAxios } from "../axios.config";
import { WeeklyContext } from "../Context/WeeklyContext";
import styled from "styled-components";
import { AllCourseContext } from "../Context/AllCourse";
import { useHistory, Link } from "react-router-dom";
import { AiFillLock, AiFillUnlock } from "react-icons/ai";

const GetWeeklyContent = () => {
	const { id, setId, result, setResult } = useContext(WeeklyContext);
	const { course, setCourse, courseId, setCourseId } =
		useContext(AllCourseContext);
	const [click, setClick] = useState(true);
	// const [isLocked, setIsLocked] = useState(true);
	const [locked, setLocked] = useState();
	const [crId, setCrId] = useState();
	const [callApi, setCallApi] = useState(true);

	const handleClick = async (e) => {
		e.preventDefault();
		await developAxios(localStorage.getItem("token"))
			.get(`/pd-online/getWeeklyContent/${courseId}`)
			.then(({ data }) => {
				console.log(data);
				setResult(data.data);
				const a = data.data[0].courseId;
				setCrId(a);
				console.log(a);
				console.log(result);
			})
			.catch((e) => {
				console.log(e);
			});
		setClick(false);
	};

	// useEffect(() => {
	//   handleClick();
	// }, []);

	const handleChange = (e) => {
		setId(e.target.value);
	};

	const handleLock = (id) => {
		developAxios(localStorage.getItem("token"))
			.put("/pd-online/lock-weekly-content", {
				courseId: crId,
				weeklyContentId: id,
			})
			.then(({ data }) => {
				console.log(data.message);
				setCallApi(!callApi);
			})
			.catch((e) => {
				console.log(e, "deepesh");
			});
	};
	// console.log(e);
	console.log(locked);
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get(`/pd-online/getWeeklyContent/${id}`)
			.then(({ data }) => {
				console.log(data);
				setResult(data.data);
				const a = data.data[0].courseId;
				setCrId(a);
			})
			.catch((e) => {
				console.log(e);
			});
	}, [callApi]);

	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("smallCourses/getAllcourses")
			.then(({ data }) => {
				setCourse(data.data);
				setCourseId(data.data[0]._id);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);

	// console.log(locked, "locked ki value aagyi hai");
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignContent: "center",
				padding: "20px 20px",
				alignItems: "center",
			}}
		>
			{click ? (
				<>
					<div className="w-96">
						<select
							className="  block
            w-full
            px-3
            py-1.5
            text-base
            font-normal
            text-gray-700
            bg-white bg-clip-padding bg-no-repeat
            border border-solid border-gray-300
            rounded
            transition
            ease-in-out
            mb-5
           1/2 w-
            focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
							aria-label="Default select example"
							onChange={handleChange}
						>
							{course.map((ele) => {
								return (
									<option value={ele._id} key={ele._id}>
										{ele.name}
									</option>
								);
							})}
						</select>
						<button
							className="  rounded-full
              bg-sky-500 hover:bg-sky-700 ... py-2 px-4 text-stone-50  ml-28"
							onClick={handleClick}
						>
							Get Data
						</button>
					</div>
				</>
			) : (
				<>
					{result.map((ele) => {
						return (
							<>
								<div
									style={{
										display: "flex",
										flexDirection: "row",
									}}
								>
									<p
										className="leading-normal pb-2 pt-2"
										key={ele._id}
									>
										{" "}
										{ele.topic}
									</p>
									{ele.locked ? (
										<AiFillLock
											style={{
												cursor: "pointer",
												marginTop: "10px",
												marginLeft: "10px",
											}}
											onClick={() => {
												handleLock(ele._id);
											}}
										/>
									) : (
										<AiFillUnlock
											style={{
												cursor: "pointer",
												marginTop: "10px",
												marginLeft: "10px",
											}}
											onClick={() => {
												handleLock(ele._id);
											}}
										/>
									)}
								</div>
								<Link to={`/get-assignment-types${ele._id}`}>
									{" "}
									<button
										className="rounded-full
                    bg-sky-500 hover:bg-sky-700 py-2 px-4 text-stone-50 "
									>
										{`Get ${ele.topic} Assignment`}
									</button>
								</Link>{" "}
							</>
						);
					})}
				</>
			)}
		</div>
	);
};

export default GetWeeklyContent;
